// Unique symbols for nominal types
const nidSymbol = Symbol('NID');
const eidSymbol = Symbol('EID');

/**
 * A node identifier.
 */
export type NID = string | (string & { readonly [nidSymbol]: unique symbol });

/**
 * An edge identifier.
 */
export type EID = string | (string & { readonly [eidSymbol]: unique symbol });

/**
 * A set of node IDs
 */
export type Nodes = Set<NID>;

/**
 * A set of edge IDs
 */
export type Edges = Set<EID>;

export enum EdgeDirection {
  TAIL = 'tail',
  HEAD = 'head'
}

export function reverseEdgeDirection(direction: EdgeDirection): EdgeDirection {
  return direction === EdgeDirection.HEAD ? EdgeDirection.TAIL : EdgeDirection.HEAD;
}

export interface EdgeEndpoint {
  edge: EID;
  direction: EdgeDirection;
}
